/**
 * @generated SignedSource<<f1c2c133078522cb54b13f04e459d2fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilteredSurveyInput = {
  PIISurveys?: boolean | null;
  historicSurveys?: boolean | null;
  trackingParams?: ReadonlyArray<TrackingParam | null> | null;
  webcamSurveys?: boolean | null;
};
export type TrackingParam = {
  key: string;
  value: string;
};
export type useEarnQuery$variables = {
  input: FilteredSurveyInput;
};
export type useEarnQuery$data = {
  readonly consentSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TermsAndConditionsConsent_consentSettings">;
  } | null;
  readonly notificationSubscriptions: {
    readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  };
  readonly profilerUrl: string | null;
  readonly signupSurveyUrl: string | null;
  readonly surveys: {
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly targetRedemptionValue: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_target">;
  } | null;
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly walletBalance: {
    readonly " $fragmentSpreads": FragmentRefs<"RedeemBanner_balance">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef" | "useNoSurveysFragmentQuery_noSurveysRef" | "useSurveyListFragmentQuery_surveysRef">;
};
export type useEarnQuery = {
  response: useEarnQuery$data;
  variables: useEarnQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilerUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupSurveyUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surveyInviteContactChannels",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subUnitAmount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEarnQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_balance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedeemBanner_target"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "useSurveyListFragmentQuery_surveysRef"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useMoreSurveysBannerQuery_profileUrlRef"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TermsAndConditionsConsent_consentSettings"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useNoSurveysFragmentQuery_noSurveysRef"
      },
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEarnQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "panelistCost",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "redemptionAmount",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "rewardAmount",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "baseReward",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cents",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LockedSurveyInfo",
                    "kind": "LinkedField",
                    "name": "lockedInfo",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DurationDetails",
                    "kind": "LinkedField",
                    "name": "durationDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "providerDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "studyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AdminSurveyData",
                    "kind": "LinkedField",
                    "name": "adminData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rankScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyGuid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "surveyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demographicProfileUrl",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileCompletion",
        "kind": "LinkedField",
        "name": "profileCompletionPercentage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileCompletionPercentage",
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "consentSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consentedVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "1afd183e0575465f5a65c0c46561db86",
    "id": null,
    "metadata": {},
    "name": "useEarnQuery",
    "operationKind": "query",
    "text": "query useEarnQuery(\n  $input: FilteredSurveyInput!\n) {\n  walletBalance {\n    ...RedeemBanner_balance\n    id\n  }\n  targetRedemptionValue {\n    ...RedeemBanner_target\n  }\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    id\n  }\n  ...useSurveyListFragmentQuery_surveysRef_2VV6jB\n  ...useMoreSurveysBannerQuery_profileUrlRef\n  consentSettings {\n    ...TermsAndConditionsConsent_consentSettings\n  }\n  ...useNoSurveysFragmentQuery_noSurveysRef\n  profilerUrl\n  signupSurveyUrl\n  notificationSubscriptions {\n    surveyInviteContactChannels\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n\nfragment PushNotificationsCardFragment_notificationSubscriptions on NotificationSubscriptions {\n  surveyInviteContactChannels\n}\n\nfragment RedeemBanner_balance on WalletBalance {\n  amount {\n    formatted\n    subUnitAmount\n  }\n  id\n}\n\nfragment RedeemBanner_target on AmountDenomination {\n  panelistCost {\n    subUnitAmount\n  }\n  redemptionAmount {\n    formatted\n  }\n}\n\nfragment TermsAndConditionsConsent_consentSettings on ConsentSettingsConnection {\n  currentVersion\n  consentedVersion\n}\n\nfragment useFinishedSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  title\n  status\n  statusDescription\n  supportId\n  surveyId\n  studyId\n  tags\n  startedAt\n  rewardAmount {\n    formatted\n  }\n  durationDetails {\n    providerDuration\n  }\n}\n\nfragment useMoreSurveysBannerQuery_profileUrlRef on Query {\n  endlessProfilerUrl\n  demographicProfileUrl\n  profilerUrl\n  profileCompletionPercentage {\n    profileCompletionPercentage\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n\nfragment useNoSurveysFragmentQuery_noSurveysRef on Query {\n  endlessProfilerUrl\n  profilerUrl\n  userData {\n    firstName\n    id\n  }\n  notificationSubscriptions {\n    ...PushNotificationsCardFragment_notificationSubscriptions\n    id\n  }\n}\n\nfragment useSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  iconUrl\n  rewardAmount {\n    formatted\n    subUnitAmount\n    currency\n  }\n  baseReward {\n    cents\n    currency\n    formatted\n  }\n  lockedInfo {\n    title\n  }\n  title\n  url\n  status\n  supportId\n  durationDetails {\n    providerDuration\n  }\n  tags\n  studyId\n  adminData {\n    rankScore\n    surveyGuid\n  }\n}\n\nfragment useSurveyListFragmentQuery_surveysRef_2VV6jB on Query {\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        tags\n        status\n        url\n        ...useSurveyCardFragmentQuery_surveyRef\n        ...useFinishedSurveyCardFragmentQuery_surveyRef\n      }\n    }\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bffc43bbdceab207f13bbf9084d9ea52";

export default node;
